import { Component, OnInit } from '@angular/core'

import { SingleSignOnService } from '../single-sign-on.service'

@Component({
  selector: 'app-drop-off',
  templateUrl: './drop-off.component.html',
  styleUrls: ['./drop-off.component.scss']
})
export class DropOffComponent implements OnInit {
  constructor(
    private _singleSignOnService: SingleSignOnService
  ) {
  }

  public ngOnInit() {
    this._singleSignOnService.dropOff().subscribe()
  }
}
